
import Hero from './components/Hero';
import About from './components/About';
import Inventory from './components/Inventory';
import Scheduler from './components/Scheduler';
import Testimonials from './components/Testimonials';
import Social from './components/Social';

export default function Home() {
  return (
    <div className="bg-black min-h-screen">
      <Hero />
      <About />
      <Inventory />
      <Scheduler />
      <Testimonials />
      <Social />
    </div>
  );
}
